"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleContainer = exports.StyledSaveForLater = exports.StyledProductcard = exports.ProductDetails = exports.ImageWrapper = exports.CardContainer = exports.BrandContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fuseVariables = require("@tvg/fuse-variables");
var _fuseTypographyElement = _interopRequireDefault(require("@tvg/fuse-typography-element"));
var _fuseSave = _interopRequireDefault(require("@tvg/fuse-save"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CardContainer = exports.CardContainer = _styledComponents["default"].div.attrs({
  className: 'fuse-list-view-product-card'
}).withConfig({
  displayName: "styled-list-view-product-card__CardContainer",
  componentId: "sc-1rvsae2-0"
})(["width:100%;min-width:100%;position:relative;"]);
var StyledProductcard = exports.StyledProductcard = _styledComponents["default"].a.attrs({
  className: 'fuse-list-view-product-card__link',
  'data-testid': 'fuse-list-view-product-card__link'
}).withConfig({
  displayName: "styled-list-view-product-card__StyledProductcard",
  componentId: "sc-1rvsae2-1"
})(["display:flex;position:relative;width:100%;min-height:104px;padding:var(--spacing-global-space2) var(--spacing-global-space3) var(--spacing-global-space3);text-decoration:none;&:focus-visible{outline:var(--border-width-s) solid var(--color-functional-focus);}&:focus:not(:focus-visible){outline:none;}"]);
var ImageWrapper = exports.ImageWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-list-view-product-card__image-wrapper',
  'data-testid': 'fuse-list-view-product-card__image-wrapper'
}).withConfig({
  displayName: "styled-list-view-product-card__ImageWrapper",
  componentId: "sc-1rvsae2-2"
})(["display:flex;width:calc(4.3125rem * 1.6);flex-direction:column;align-items:stretch;flex-shrink:0;gap:var(--spacing-global-space4);"]);
var ProductDetails = exports.ProductDetails = _styledComponents["default"].div.attrs({
  className: 'fuse-list-view-product-card__details',
  'data-testid': 'fuse-list-view-product-card__details'
}).withConfig({
  displayName: "styled-list-view-product-card__ProductDetails",
  componentId: "sc-1rvsae2-3"
})(["display:flex;flex-direction:column;justify-content:start;align-items:flex-start;flex:1 0 0;align-self:stretch;margin-left:var(--spacing-global-space4);margin-right:calc(var(--spacing-global-space2) + var(--spacing-global-space6));@media only screen and (min-width:", "){margin-right:calc(var(--spacing-global-space4) + var(--spacing-global-space6));}@media only screen and (min-width:", "){margin-right:calc(var(--spacing-global-space2) + var(--spacing-global-space6));}"], _fuseVariables.breakpoints.m.minWidth, _fuseVariables.breakpoints.l.minWidth);
var BrandContainer = exports.BrandContainer = (0, _styledComponents["default"])(_fuseTypographyElement["default"]).attrs({
  className: 'fuse-list-view-product-card__brand',
  'data-testid': 'fuse-list-view-product-card__brand'
}).withConfig({
  displayName: "styled-list-view-product-card__BrandContainer",
  componentId: "sc-1rvsae2-4"
})(["margin-bottom:var(--spacing-global-space2);min-height:calc(var(--font-size-1) + 4px);display:block;max-width:100%;text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"]);
var TitleContainer = exports.TitleContainer = (0, _styledComponents["default"])(_fuseTypographyElement["default"]).attrs({
  className: 'fuse-list-view-product-card__title',
  'data-testid': 'fuse-list-view-product-card__title'
}).withConfig({
  displayName: "styled-list-view-product-card__TitleContainer",
  componentId: "sc-1rvsae2-5"
})(["display:block;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;margin-bottom:var(--spacing-global-space2);"]);
var StyledSaveForLater = exports.StyledSaveForLater = (0, _styledComponents["default"])(_fuseSave["default"]).attrs({
  className: 'fuse-list-view-product-card__save-for-later',
  'data-testid': 'fuse-list-view-product-card__save-for-later',
  'data-cnstrc-btn': 'add_to_wishlist'
}).withConfig({
  displayName: "styled-list-view-product-card__StyledSaveForLater",
  componentId: "sc-1rvsae2-6"
})(["position:absolute;top:var(--spacing-global-space2);right:0;padding:0;&:focus-visible{outline-offset:0;}@media only screen and (min-width:", "){right:var(--spacing-global-space3);}@media only screen and (min-width:", "){right:0;}"], _fuseVariables.breakpoints.m.minWidth, _fuseVariables.breakpoints.l.minWidth);